import { Alert } from "antd";

import { formatDate } from "@/shared/utils/formaters/dataFormater/formatDate";
import { pluralize } from "@/shared/utils/pluralize";

import style from "./style.module.css";

interface IReportExpirationBannerProps {
  completedOn: Date;
  resultValidityDays: number;
}

export function ReportExpirationBanner({ completedOn, resultValidityDays }: IReportExpirationBannerProps) {
  const completedOnFormatted = formatDate(completedOn.toISOString(), "MMMM D, YYYY");

  return (
    <Alert
      className={style.banner}
      type="warning"
      showIcon
      message="Assessment results are no longer valid"
      description={`This assessment was completed on ${completedOnFormatted} and is considered expired after ${resultValidityDays} ${pluralize(
        "day",
        resultValidityDays,
      )}. Results may no longer reflect the candidate's current abilities and should not be relied upon for decision-making.`}
    />
  );
}
